import { FC } from 'react';

import styles from './styles.module.scss';

export const SkeletonSchedule: FC = () => {
  const tables = new Array(25).fill(1);

  return (
    <div className={styles['skeleton-schedule']}>
      {tables.map((cardsCount, columnIndex) => (
        <div
          key={columnIndex}
          className={styles['skeleton-schedule__container']}
        >
          <div className={styles['skeleton-schedule__date']}></div>
          {Array(cardsCount)
            .fill(null)
            .map((_, cardIndex) => (
              <div
                key={cardIndex}
                className={styles['skeleton-schedule__table']}
              />
            ))}
        </div>
      ))}
    </div>
  );
};
